import moment from "moment"
import { StartUpperCase } from "./Format"
import { env } from "../../../../core/Env"
import { useContext } from "react"
import { ToolContext } from "../../../../core/context/ToolContext"
import { useShowRealProperty } from "../../global/GlobalFunctions"

export const FeatureIdState = (name) =>{
    if (env() === 'sb') {
        return 'sb'
    }else if(env() === 'prod'){
        return 'prod'
    }else{
        let state = {
			// HRC MAIN FEATURES
			"campaign": 883,
			"sales": 899,
			"reports": 888,
			"setup": 894,
			"online-solutions": 905,
			"business-development": 911,
			"leads-management": 907,
			// MARKETING CAMPAIGN SUB-FEATURES
			// "call_monitoring": 884,
			// "poster": 885,
			// "promo_page": 886,
			// "creative_brief": 887,
			// // SALES SUB-FEATURES
			// product: 900,
			// sales_membership: 901,
			// sales_training: 902,
			// sales_real_property: 903,
			// booking: 904,
			// // LEAD MANAGEMENT SUB-FEATURES
			// agent_application: 908,
			// property_inquiries: 909,
			// inquiries: 910,
			// // SETUP SUB-FEATURES
			// contact: 895,
			// setup_real_property: 896,
			// setup_training: 897,
			// setup_membership: 898,
			// // ONLINE SOLUTIONS SUB-FEATURES
			// e_commerce: 906,
			// // REPORTS SUB-FEATURES
			// call_record: 889,
			// reports_sales: 890,
			// sales_receivables: 891,
			// reviews_and_rating: 892,
			// social_media_insights: 893,
			// BUSINESS DEVELOPMENT SUB-FEATURES
			// business_development_sales: 912,
			// targets: 913,
			// task_approvals: 914,
			// proposals: 915,
			// clients: 916,ss
			// leads: 917,
			// dashboard: 918,
			// online_solution: 234,
		}
        return state[name]
    }
}
    //    1: "Create",
    //     2: "Read",
    //     3: "Update",
    //     4: "Download",
    //     5: "Export",
	//     6: "Post",
	// 	   7: "View",
export const useRoleState = (/* role_type */) => {
	const showRP = useShowRealProperty()
	const { personalization_state } = useContext(ToolContext)

	const hasIndustry = (id) => personalization_state.selected.data.some(v => v.id === id)

    // if (role_type === 'Super Admin' || role_type === 'Admin') {
        return [
            {id:FeatureIdState('campaign'), feature_name:'campaign', path:`${FeatureIdState('campaign')}`, action:[],
                sub:[
                    {id:1, feature_name:'creative-brief', path:`${FeatureIdState('campaign')}->1`, action:[],
						sub_2:[
                            ...(hasIndustry(1) ? [{id:1, feature_name:'product-creative-brief', path:`${FeatureIdState('campaign')}->1->1`, action:[1, 3]}] : []),
                            ...(hasIndustry(2) ? [{id:2, feature_name:'booking-creative-brief', path:`${FeatureIdState('campaign')}->1->2`, action:[1, 3]}] : []),
							...(showRP ? [{id:3, feature_name:'real-property-creative-brief', path:`${FeatureIdState('campaign')}->1->3`, action:[1, 3]}] : []),
							...(hasIndustry(4) ? [{id:4, feature_name:'training-creative-brief', path:`${FeatureIdState('campaign')}->1->4`, action:[1, 3]}] : []),
							...(hasIndustry(3) ? [{id:5, feature_name:'membership-creative-brief', path:`${FeatureIdState('campaign')}->1->5`, action:[1, 3]}] : []),
                        ]
					},
                    ...((hasIndustry(1) || hasIndustry(2)) ? [{id:2, feature_name:'promo-page', path:`${FeatureIdState('campaign')}->2`, action:[],
						sub_2:[
                            ...(hasIndustry(1) ? [{id:1, feature_name:'product-promo-page', path:`${FeatureIdState('campaign')}->2->1`, action:[1, 3, 6]}] : []),
                            ...(hasIndustry(2) ? [{id:2, feature_name:'booking-promo-page', path:`${FeatureIdState('campaign')}->2->2`, action:[1, 3, 6]}] : []),
                        ]
					}] : []),
                    {id:3, feature_name:'poster', path:`${FeatureIdState('campaign')}->3`, action:[],
						sub_2:[
                            ...(hasIndustry(4) ? [{id:1, feature_name:'training-poster', path:`${FeatureIdState('campaign')}->3->1`, action:[1, 3, 4, 6, 7]}] : []),
                            ...(hasIndustry(3) ? [{id:2, feature_name:'career-poster', path:`${FeatureIdState('campaign')}->3->2`, action:[1, 3, 4, 6, 7]}] : []),
                        ]
					},
					// ...(showRP ? [{id:4, feature_name:'sales-page', path:`${FeatureIdState('campaign')}->4`, action:[1, 3]}] : []),
                    {id:5, feature_name:'call-monitoring', path:`${FeatureIdState('campaign')}->5`, action:[],
						sub_2:[
                            ...(hasIndustry(1) ? [{id:1, feature_name:'product-call-monitoring', path:`${FeatureIdState('campaign')}->5->1`, action:[1, 3]}] : []),
                            ...(hasIndustry(2) ? [{id:2, feature_name:'booking-call-monitoring', path:`${FeatureIdState('campaign')}->5->2`, action:[1, 3]}] : []),
							...(showRP ? [{id:3, feature_name:'real-property-call-monitoring', path:`${FeatureIdState('campaign')}->5->3`, action:[1, 3]}] : []),
							...(hasIndustry(4) ? [{id:4, feature_name:'training-call-monitoring', path:`${FeatureIdState('campaign')}->5->4`, action:[1, 3]}] : []),
							...(hasIndustry(3) ? [{id:5, feature_name:'membership-call-monitoring', path:`${FeatureIdState('campaign')}->5->5`, action:[1, 3]}] : []),
                        ]
					},
                ]
            },
			// SALES IF IIMPLEMENT YUNG READ
			{id:FeatureIdState('sales'), feature_name:'sales', path:`${FeatureIdState('sales')}`, action:[],
                sub:[
                    ...(hasIndustry(1) ? [{id:1, feature_name:'product-sales', path:`${FeatureIdState('sales')}->1`, action:[],
						sub_2:[
                            {id:1, feature_name:'received-product-sales', path:`${FeatureIdState('sales')}->1->1`, action:[3, 7]},
                            {id:2, feature_name:'preparing-product-sales', path:`${FeatureIdState('sales')}->1->2`, action:[3, 7]},
							{id:3, feature_name:'shipped-product-sales', path:`${FeatureIdState('sales')}->1->3`, action:[3, 7]},
							{id:4, feature_name:'delivered-product-sales', path:`${FeatureIdState('sales')}->1->4`, action:[7]},
							{id:5, feature_name:'confirmed-product-sales', path:`${FeatureIdState('sales')}->1->5`, action:[7]},
                        ]
					}] : []),
					...(hasIndustry(2) ? [{id:2, feature_name:'booking-sales', path:`${FeatureIdState('sales')}->2`, action:[],
						sub_2:[
                            {id:1, feature_name:'booked-booking-sales', path:`${FeatureIdState('sales')}->2->1`, action:[3, 7]},
                            {id:2, feature_name:'checkin-booking-sales', path:`${FeatureIdState('sales')}->2->2`, action:[3, 7]},
							{id:3, feature_name:'checkout-booking-sales', path:`${FeatureIdState('sales')}->2->3`, action:[7]},
                        ]
					}] : []),
                    ...(hasIndustry(4) ? [{id:3, feature_name:'training-sales', path:`${FeatureIdState('sales')}->3`, action:[7]}] : []),
                    ...(hasIndustry(3) ? [{id:4, feature_name:'membership-sales', path:`${FeatureIdState('sales')}->4`, action:[7]}] : []),
                ]
            },
			// SALES IF IIMPLEMENT YUNG READ
            ...(showRP ? [{id:FeatureIdState('leads-management'), feature_name:'leads-management', path:`${FeatureIdState('leads-management')}`, action:[],
                sub:[
                    {id:1, feature_name:'agent-application', path:`${FeatureIdState('leads-management')}->1`, action:[7]},
                    {id:2, feature_name:'property-inquiries', path:`${FeatureIdState('leads-management')}->2`, action:[7, 3]},
                    {id:3, feature_name:'inquiries', path:`${FeatureIdState('leads-management')}->3`, action:[7]},
                ]
            }] : []),
            {id:FeatureIdState('setup'), feature_name:'setup', path:`${FeatureIdState('setup')}`, action:[],
                sub:[
                    {id:1, feature_name:'contact', path:`${FeatureIdState('setup')}->1`, action:[],
						sub_2:[
                            ...(hasIndustry(1) ? [{id:1, feature_name:'product-contact', path:`${FeatureIdState('setup')}->1->1`, action:[1, 7]}] : []),
                            ...(hasIndustry(2) ? [{id:2, feature_name:'booking-contact', path:`${FeatureIdState('setup')}->1->2`, action:[1, 7]}] : []),
							...(showRP ? [{id:3, feature_name:'real-property-contact', path:`${FeatureIdState('setup')}->1->3`, action:[1, 7]}] : []),
							...(hasIndustry(4) ? [{id:4, feature_name:'training-contact', path:`${FeatureIdState('setup')}->1->4`, action:[1, 7]}] : []),
							...(hasIndustry(3) ? [{id:5, feature_name:'membership-contact', path:`${FeatureIdState('setup')}->1->5`, action:[1, 7]}] : []),
                        ]
					},
                    ...(showRP ? [{id:2, feature_name:'real-property-setup', path:`${FeatureIdState('setup')}->2`, action:[1,3,6,7]}] : []),
                    ...(hasIndustry(4) ? [{id:3, feature_name:'training-setup', path:`${FeatureIdState('setup')}->3`, action:[1,3,7]}] : []),
					...(hasIndustry(3) ? [{id:4, feature_name:'membership-setup', path:`${FeatureIdState('setup')}->4`, action:[1,3,7]}] : []),
                ]
            },
			...(showRP ? [{id:FeatureIdState('online-solutions'), feature_name:'online-solutions', path:`${FeatureIdState('online-solutions')}`, action:[],
                sub:[
                    {id:1, feature_name:'e-commerce', path:`${FeatureIdState('online-solutions')}->1`, action:[1,3,6,7]},
                ]
            }] : []),
			// VALIDATE PA YUNG REPORTS IF READ LANG
			{id:FeatureIdState('reports'), feature_name:'reports', path:`${FeatureIdState('reports')}`, action:[],
                sub:[
                    {id:1, feature_name:'call-record', path:`${FeatureIdState('reports')}->1`, action:[],
						sub_2:[
                            ...(hasIndustry(1) ? [{id:1, feature_name:'product-call-record', path:`${FeatureIdState('reports')}->1->1`, action:[7]}] : []),
                            ...(hasIndustry(2) ? [{id:2, feature_name:'booking-call-record', path:`${FeatureIdState('reports')}->1->2`, action:[7]}] : []),
							...(showRP ? [{id:3, feature_name:'real-property-call-record', path:`${FeatureIdState('reports')}->1->3`, action:[7]}] : []),
							...(hasIndustry(4) ? [{id:4, feature_name:'training-call-record', path:`${FeatureIdState('reports')}->1->4`, action:[7]}] : []),
							...(hasIndustry(3) ? [{id:5, feature_name:'membership-call-record', path:`${FeatureIdState('reports')}->1->5`, action:[7]}] : []),
                        ]
					},
					...((hasIndustry(1) || hasIndustry(2)) ? [{id:2, feature_name:'reports-sales', path:`${FeatureIdState('reports')}->2`, action:[],
						sub_2:[
                            ...(hasIndustry(1) ? [{id:1, feature_name:'product-reports-sales', path:`${FeatureIdState('reports')}->2->1`, action:[7]}] : []),
                            ...(hasIndustry(2) ? [{id:2, feature_name:'booking-reports-sales', path:`${FeatureIdState('reports')}->2->2`, action:[7]}] : []),
                        ]
					}] : []),
					...((hasIndustry(1) || hasIndustry(2) || hasIndustry(4)) ? [{id:3, feature_name:'sales-receivables', path:`${FeatureIdState('reports')}->3`, action:[],
						sub_2:[
                            ...(hasIndustry(1) ? [{id:1, feature_name:'product-sales-receivables', path:`${FeatureIdState('reports')}->3->1`, action:[7]}] : []),
                            ...(hasIndustry(2) ? [{id:2, feature_name:'booking-sales-receivables', path:`${FeatureIdState('reports')}->3->2`, action:[7]}] : []),
							...(hasIndustry(4) ? [{id:3, feature_name:'training-sales-receivables', path:`${FeatureIdState('reports')}->3->3`, action:[7]}] : []),
                        ]
					}] : []),
					...((hasIndustry(1) || hasIndustry(2)) ? [{id:4, feature_name:'reviews-and-rating', path:`${FeatureIdState('reports')}->4`, action:[],
						sub_2:[
                            ...(hasIndustry(1) ? [{id:1, feature_name:'product-reviews-and-rating', path:`${FeatureIdState('reports')}->4->1`, action:[7]}] : []),
                            ...(hasIndustry(2) ? [{id:2, feature_name:'booking-reviews-and-rating', path:`${FeatureIdState('reports')}->4->2`, action:[7]}] : []),
                        ]
					}] : []),
					{id:5, feature_name:'social-media-insights', path:`${FeatureIdState('reports')}->5`, action:[7]},
                ]
            },
			// {id:FeatureIdState('business-development'), feature_name:'business-development', path:`${FeatureIdState('business-development')}`, action:[],
            //     sub:[
            //         {id:1, feature_name:'business-development_sales', path:`${FeatureIdState('business-development')}->1`, action:[]},
			// 		{id:2, feature_name:'targets', path:`${FeatureIdState('business-development')}->2`, action:[1,3]},
			// 		{id:3, feature_name:'task_approvals', path:`${FeatureIdState('business-development')}->3`, action:[1,3]},
			// 		{id:4, feature_name:'proposals', path:`${FeatureIdState('business-development')}->4`, action:[1,3]},
			// 		{id:5, feature_name:'clients', path:`${FeatureIdState('business-development')}->5`, action:[1,3]},
			// 		{id:6, feature_name:'leads', path:`${FeatureIdState('business-development')}->6`, action:[1,3]},
			// 		{id:7, feature_name:'dashboard', path:`${FeatureIdState('business-development')}->7`, action:[1,3]},
            //     ]
            // },
        ]
    // }
}

export const useFeatureState = (type, role_type) => {
    const fs = useRoleState(role_type)
    return FeatureState(type, fs)
}

export const FeatureState = (type, fs) => {
    // action: 1 = Create, 2 = Read, 3 = Update, 4 = Download, 5 = Export, 
    
    // let fs = RoleState(role_type)
    
    if (type === 'all') {
        return fs
    }else if (type === 'most-used-page' || type === 'usage-detailed') {
        const FlattenArrays = (data) => {
            let result = [];

            const processItem = (item, parentPath = '') => {
                result.push({ feature_name: item.feature_name, path: parentPath || item.path, action:item.action });

                // Check for nested sub arrays (sub, sub_2, sub_3, etc.)
                Object.keys(item).forEach(key => {
                    if (key.startsWith('sub') && Array.isArray(item[key])) {
                        item[key].forEach(subItem => {
                            processItem(subItem, `${parentPath || item.path}->${subItem.path.split('->').pop()}`);
                        });
                    }
                });
            };

            data.forEach(item => processItem(item));
            return result;
        };
        let res = FlattenArrays(fs)
        return res
    }else{
        const findFeature = (data, targetFeatureName) => {
            for (const i of data) {
                if (i.feature_name.toLowerCase() === targetFeatureName.toLowerCase()) {
                    return i
                }
                if (i.sub) {
                    const found_data = findFeature(i.sub, targetFeatureName)
                    if (found_data) return found_data
                }
                if (i.sub_2) {
                    const found_data = findFeature(i.sub_2, targetFeatureName)
                    if (found_data) return found_data
                }
            }
            return null
        }
        const filter = findFeature(fs, type)
        return filter
    }
}

export const getAllFeatureTask = (res_target, res_data) => {
    const actionMap = {
        1: "Create",
        // 2: "Read",
        3: "Update",
        4: "Download",
        5: "Export",
		6: "Post",
		7: "View",
    };

    const result = [];

    res_target.forEach(item => {

        // Remove sub features (those containing "->")
        if (item.path.includes("->")) return;

        // group all items with same feature path
        const group = res_target.filter(v => v.path.startsWith(item.path));

        const sub = [];

        // Loop all children + self
        group.forEach(grp => {
            grp.action.forEach(action => {
                const matched = res_data.find(
                    rdc =>
                        rdc.feature_name === grp.feature_name &&
                        rdc.path === grp.path &&
                        rdc.action === action
                );

                sub.push({
                    to_do: `${actionMap[action]} ${StartUpperCase(grp.feature_name)}`,
                    count: matched ? matched.count : 0,
                });
            });
        });

        // Remove duplicates
        const unique = [];
        const map = new Set();
        sub.forEach(sub => {
            if (!map.has(sub.to_do)) {
                map.add(sub.to_do);
                unique.push(sub);
            }
        });

        if (unique.length > 0) {
            result.push({
                feature_name: item.feature_name,
                path: item.path,
                action: item.action,
                sub: unique,
            });
        }
    });

    return result
}

export const FetchingGraphDates = async(interval, sequence, order, date, quarter) => {

    let dates
    let datasets = {load: 'data', label: [], counts: []}

    if (interval === 'daily') {
        let nd = new Date(date)
        dates = [[`${date} 00:00:01`, `${date} 23:59:59`]]
        for (let i = 1; i < sequence; i++) {
            if (order === 'desc') {
                dates = [[`${moment(nd).subtract(i, "days").format("MM-DD-YYYY")} 00:00:01`, `${moment(nd).subtract(i, "days").format("MM-DD-YYYY")} 23:59:59`], ...dates]
            } else {
                dates = [...dates, [`${moment(nd).add(i, "days").format("MM-DD-YYYY")} 00:00:01`, `${moment(nd).add(i, "days").format("MM-DD-YYYY")} 23:59:59`]]
            }
        }
        datasets.label = dates.map(d => {
            let dd = new Date(d[0])
            return [`${moment(dd).format("ddd")}`, `${moment(dd).format("MMM D, YY")}` ]
        })
    } else if (interval === 'weekly') {
        let nd = new Date(date)
        let nextdate = order==='desc'?`${moment(nd).subtract(6, "days").format("MM-DD-YYYY")} 00:00:01`:`${moment(nd).add(6, "days").format("MM-DD-YYYY")} 23:59:59`
        dates = [order==='desc'?[nextdate, `${date} 23:59:59`]:[`${date} 00:00:01`, nextdate]]
        for (let i = 1; i < sequence; i++) {
            let parse_nd = new Date(nextdate)
            if (order === 'desc') {
                dates = [[`${moment(parse_nd).subtract(7, "days").format("MM-DD-YYYY")} 00:00:01`, `${moment(parse_nd).subtract(1, "days").format("MM-DD-YYYY")} 23:59:59`], ...dates]
                nextdate = `${moment(parse_nd).subtract(7, "days").format("MM-DD-YYYY")}`
            } else {
                dates = [...dates, [`${moment(parse_nd).add(1, "days").format("MM-DD-YYYY")} 00:00:01`, `${moment(parse_nd).add(7, "days").format("MM-DD-YYYY")} 23:59:59`]]
                nextdate = `${moment(parse_nd).add(7, "days").format("MM-DD-YYYY")} 23:59:59`
            }
        }
        
        datasets.label = dates.map(d => {
            let nd1 = new Date(d[0])
            let nd2 = new Date(d[1])
            return [`${moment(nd1).format("MMM D, YY")}`, `to`, ` ${moment(nd2).format("MMM D, YY")}` ]
        })
    } else if (interval === 'monthly') {
        let nd = new Date(date)
        dates = [[`${moment(nd).startOf('month').format('MM-DD-YYYY')} 00:00:01`, `${moment(nd).endOf('month').format('MM-DD-YYYY')} 23:59:59`]];
        let nmonth = moment(nd).startOf('month')
        for (let i = 1; i < sequence; i++) {
            let parse_nm = new Date(nmonth)
            if (order === 'desc') {
                let m = moment(parse_nm).subtract(1, 'month')
                dates = [[`${moment(m).startOf('month').format('MM-DD-YYYY')} 00:00:01`, `${moment(m).endOf('month').format('MM-DD-YYYY')} 23:59:59`], ...dates]
                nmonth = moment(m).startOf('month')
            } else {
                let m = moment(parse_nm).add(1, 'month')
                dates = [...dates, [`${moment(m).startOf('month').format('MM-DD-YYYY')} 00:00:01`, `${moment(m).endOf('month').format('MM-DD-YYYY')} 23:59:59`]]
                nmonth = moment(m).startOf('month')
            }
        }

        datasets.label = dates.map(d => {
            let nd1 = new Date(d[0])
            return [`Month`, `of`, `${moment(nd1).format("MMM, YY")}`]
        })
    } else if (interval === 'quarterly') {
        let d = new Date(date)
        let qrt = quarter === '1st' ? '01-01' : quarter === '2nd' ? '04-01' : quarter === '3rd' ? '07-01' : '10-01'
        let nd = new Date(`${qrt}-${moment(d).format('YYYY')}`)
        let nextdate = order==='desc'?`${moment(nd).add(2, "months").endOf('month').format("MM-DD-YYYY")} 23:59:59`:`${moment(nd).add(2, "months").endOf('month').format("MM-DD-YYYY")} 23:59:59`
        dates = [order==='desc'?[nextdate, `${moment(nd).format('MM-DD-YYYY')} 00:00:01`]:[`${moment(nd).format('MM-DD-YYYY')} 00:00:01`, nextdate]]
        
        for (let i = 1; i < sequence; i++) {
            let parse_nd = new Date(nextdate)
            if (order === 'desc') {
                dates = [[`${moment(parse_nd).subtract(3, "months").endOf('month').format("MM-DD-YYYY")} 23:59:59`, `${moment(parse_nd).subtract(5, "months").startOf('month').format("MM-DD-YYYY")} 00:00:01`], ...dates]
                nextdate = `${moment(parse_nd).subtract(3, "months").format("MM-DD-YYYY")}`
            } else {
                dates = [...dates, [`${moment(parse_nd).add(2, "days").startOf('month').format("MM-DD-YYYY")} 00:00:01`, `${moment(parse_nd).add(3, "months").endOf('month').format("MM-DD-YYYY")} 23:59:59`]]
                nextdate = `${moment(parse_nd).add(3, "months").format("MM-DD-YYYY")} 23:59:59`
            }
        }

        datasets.label = dates.map(d => {
            let nd1 = new Date(d[0])
            let nd2 = new Date(d[1])
            return [`${moment(nd1).format("MMM D, YY")}`, `to`, ` ${moment(nd2).format("MMM D, YY")}` ]
        })
        
    } else if (interval === 'yearly') {
        let nd = new Date(date)
        dates = [[moment(nd).format('[01-01]-YYYY [00:00:01]'), moment(nd).format('[12-31]-YYYY [23:59:59]')]]
        let nyear = moment(nd)
        for (let i = 1; i < sequence; i++) {
            let parse_ny = new Date(nyear)
            if (order === 'desc') {
                let m = moment(parse_ny).subtract(1, 'year')
                dates = [[moment(m).format('[01-01]-YYYY [00:00:01]'), moment(m).format('[12-31]-YYYY [23:59:59]')], ...dates]
                nyear = moment(m).format('[01-01]-YYYY')
            } else {
                let m = moment(parse_ny).add(1, 'year')
                dates = [...dates, [moment(m).format('[01-01]-YYYY [00:00:01]'), moment(m).format('[12-31]-YYYY [23:59:59]')]]
                nyear = moment(m).format('[01-01]-YYYY')
            }
        }

        datasets.label = dates.map(d => {
            let nd1 = new Date(d[0])
            return [`Year`, `of`, `${moment(nd1).format("YYYY")}`]
        })
    }

    const firstStart = dates[0][0];
    const lastEnd = dates[dates.length - 1][1]; 

    return {
        label:datasets.label,
        dates:dates, 
        start_date:firstStart,
        last_date:lastEnd
    }
}

